import { Stack, TextField } from '@mui/material';
import { FieldEditorSection } from 'components/FieldEditor/types/FieldEditorSection';
import React from 'react';

import { InputArea } from '../InputArea';

export function BooleanMeta({ field, setField }: FieldEditorSection) {
  const meta = field.meta || {};

  const updateMeta = (updates: any) => {
    setField({
      ...field,
      meta: {
        ...meta,
        ...updates,
      },
    });
  };

  const booleanMeta: any = meta['blackframe.boolean'] || {};

  return (
    <InputArea name="Meta" description="Meta configuration for sortable fields">
      <Stack direction="row" gap={3}>
        <TextField
          label="True Label"
          value={booleanMeta?.trueLabel ?? ''}
          onChange={(e) =>
            updateMeta({
              'blackframe.boolean': {
                ...booleanMeta,
                trueLabel: e.target.value,
              },
            })
          }
          fullWidth
        />
        <TextField
          label="False Label"
          value={booleanMeta?.falseLabel ?? ''}
          onChange={(e) =>
            updateMeta({
              'blackframe.boolean': {
                ...booleanMeta,
                falseLabel: e.target.value,
              },
            })
          }
          fullWidth
        />
      </Stack>
    </InputArea>
  );
}
